const getters = {
    // 购物车商品数量
    cartCount: (state) => {
        return state.cartList.length;
    }
}
export default getters